import Loader from "react-loader-spinner";
import { faCalculator } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { getStaffPerformance_ServiceTotalCost, getStaffPerformance_ServiceTotalCostMonthly } from "../store/api/Services";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { exportToExcel, isWebApp, keyIsLetterOrNumber, setErrorDialog } from "../../store/api/CommonFunctions";
import DatePicker from "react-datepicker2";
import BihamtaTable from "../../Components/BihamtaTable";
import { ClipboardData, FileEarmarkExcelFill, List, Printer, PrinterFill, Search } from "react-bootstrap-icons";
import { getSystemSettings } from "../store/api/SystemSettingsAPI";
import ModalSelectStaff from "../../Components/Modals/ModalSelectStaff";
import { Bar, BarChart, CartesianGrid, Label, ResponsiveContainer, XAxis, YAxis } from "recharts";

const StaffPerformanceTotalCostReportMonthly = () => {

    const history = useHistory();
    const dispatch = useDispatch();
    const { dataList } = useSelector(state => { return { dataList: state.service.srvTotalCostReportMonthly } });
    const [pending, setPending] = useState(false);
    const [popStaff, setPopStaff] = useState({ show: false });
    const [selectedStaff, setStaffData] = useState(null);
    const tableCols = [
        { colName: "MonthStr", colTitle: "ماه", justInMobile: true },
        { colName: "Count", colTitle: "تعداد سرویس", justInMobile: true },
        { colName: "ServicePrice", colTitle: "هزینه سرویس", colType: "currency" },
    ]
    function search() {
        if(!selectedStaff?.ID)
        {
            setErrorDialog(dispatch,"تکنسینی انتخاب نشده است","گزارش ماهانه عملکرد تکنسین");
            return;
        }
        dispatch(getStaffPerformance_ServiceTotalCostMonthly(selectedStaff?.ID));

    }
    function toExcel() {
        const url = `api/ServiceReportsAPI/GetStaffPerformance_ServiceTotalCostMonthly?staffID=${selectedStaff?.ID}&persianYear=''`;
        const searchArgs = { staffID: selectedStaff?.ID };
        setPending(true);
        exportToExcel("StaffPerformanceServiceTotalCostMonthly", searchArgs, url, "get", tableCols, () => setPending(false));
    }
    function printReport(e) {
        history.push({ 
            pathname: `/PrintViewer/StaffPerformanceServiceTotalCostMonthly/${e.ctrlKey}`,
            state: {
                dataUrl: `api/ServiceReportsAPI/GetStaffPerformance_ServiceTotalCostMonthly?staffID=${selectedStaff?.ID}&persianYear=''`,
                method: "get",
                fetchBody:JSON.stringify({StaffName:selectedStaff.LastName})
            }
        });
    }
    function showList(row) {
        history.push(`/Services/StaffPerformanceTotalCost/${selectedStaff?.Hard_Code}`);
    }
    function showModalStaff(e) {
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
                return;
            }
            e.preventDefault();
        }
        const onSelect = (data) => {
            setStaffData(data);
        }
        setPopStaff({ show: true, onSelect: onSelect });
    }
    useEffect(() => {
        document.body.classList = "notMain";
    }, [])
    return (
        <div className="container-fluid mt-2">
            <br />
            <Card>
                <ModalSelectStaff popData={popStaff} setPopSelectStaff={setPopStaff} />
                <Card.Header className="headerStyle">
                    <FontAwesomeIcon icon={faCalculator} size="lg" />&nbsp;
                    گزارش عملکرد تکنسین(ماهانه)
                </Card.Header>
                <Card.Body className="bodyStyle" style={{textAlign:"right"}}>
                    <Row>
                        <Col md={2} className="form-group">
                            <label>مشخصات تکنسین: </label>
                            <Form.Control readOnly value={selectedStaff?.LastName ?? ""} onKeyDown={showModalStaff} />
                            <Button className="btn-input-tiny" onClick={showModalStaff} style={{ marginTop: "-1px" }}><List size={20} /></Button>
                        </Col>
                        <div>
                            <Button onClick={search} className="mt-1 group-Btn-large"><ClipboardData size={18} />&nbsp;خروجی گزارش </Button>
                            <Button onClick={printReport} variant="secondary"  className="mt-1 group-Btn-large"><Printer size={18}/>&nbsp;چاپ گزارش</Button>
                        </div>
                    </Row>
                    <Row>
                        <Col md={3}>
                            {!pending &&
                                <div style={{ padding: 1, width: "100%", textAlign: "left", marginTop: "5px" }}>
                                    <FileEarmarkExcelFill onClick={toExcel} size={25} color="green" style={{ cursor: "pointer" }} className="hoverIcon" />
                                </div>}
                            {pending && <div style={{ padding: 0, width: "100%", textAlign: "left" }}><Loader type="BallTriangle" color="#bb1370" height={18} style={{ textAlign: "left", alignItems: "left" }} /></div>}
                            <BihamtaTable columns={tableCols} reducerName="service" objectName="srvTotalCostReportMonthly" fixedHeight className="mt-0" style={{ whiteSpace: "nowrap" }} rowClick={showList} />
                            {/* {isWebApp() &&
                                <div className="mt-3" style={{ color: "blue", textAlign: "left" }}>
                                    برای نمایش ریز عملکرد روی ردیف مورد نظر کلیک کنید
                                </div>
                            } */}
                        </Col>
                        <Col md={4}>
                            {dataList?.Data?.length > 0 &&
                                <ResponsiveContainer width="100%" height="100%" className="barChart" debounce={300}>
                                    <BarChart data={dataList.Data}>
                                        <XAxis dataKey="MonthStr" style={{ fontSize: "8px" }} reversed={true} minTickGap={1} width={100} height={50} angle={-30} tickMargin={8}>
                                            <Label value="ماه" offset={2} position="insideBottom" style={{ fill: "blue" }} />
                                        </XAxis>
                                        <YAxis dx={15} style={{ fontSize: "10px" }} orientation="right" padding={{ top: 15 }} tickMargin={5}
                                            label={{ value: "تعداد", angle: 90, style: { fill: "blue" } }} type="number"/>
                                        <CartesianGrid />
                                        <Bar dataKey="Count" fill="#00806c" label={{ position: 'top' }} isAnimationActive={false} />
                                    </BarChart>
                                </ResponsiveContainer>
                            }
                        </Col>  
                        <Col md={5}>
                            {dataList?.Data?.length > 0 &&
                                <ResponsiveContainer width="100%" height="100%" className="barChart" debounce={300}>
                                    <BarChart data={dataList.Data}>
                                        <XAxis dataKey="MonthStr" style={{ fontSize: "8px" }} reversed={true} minTickGap={1} width={100} height={50} angle={-30} tickMargin={8}>
                                            <Label value="ماه" offset={2} position="insideBottom" style={{ fill: "blue" }} />
                                        </XAxis>
                                        <YAxis dx={35} style={{ fontSize: "10px" }} orientation="right" padding={{ top: 15 }} tickMargin={5}
                                            label={{ value: "هزینه", angle: 90, style: { fill: "blue" } }}type="number" />
                                        <CartesianGrid />
                                        <Bar dataKey="ServicePrice" fill="#e16605" label={{ position: 'top' }} isAnimationActive={false} />
                                    </BarChart>
                                </ResponsiveContainer>
                            }
                        </Col>                                               
                    </Row>
                </Card.Body>
            </Card>
        </div>)
}
export default StaffPerformanceTotalCostReportMonthly;